module.exports = __webpack_public_path__ + "img/turn-on.5c2002c6.svg";